import { type DietaryRestriction, type Tag } from '@hungryroot/rest';
import {
  DietaryRestrictionsIdToTagsId,
  DietaryRestrictionsIngredientsId,
  type DietaryRestrictionsText,
} from './dietary-restrictions-config';

export const getDietaryIngredients = (
  tagsData: Pick<Tag, 'id'>[] = [],
  dietaryRestrictions: DietaryRestriction[]
) => {
  const tags = new Set(tagsData.map(({ id }: { id: number }) => id));
  const dietaryIngredients =
    dietaryRestrictions.reduce((acc, { id }) => {
      const dietaryIngredients =
        DietaryRestrictionsIdToTagsId[
          id as keyof typeof DietaryRestrictionsIdToTagsId
        ]?.reduce((acc, tagId) => {
          const dietaryIngredient =
            DietaryRestrictionsIngredientsId[
              tagId as keyof typeof DietaryRestrictionsIngredientsId
            ];

          if (tags.has(tagId) && dietaryIngredient) {
            return [...acc, dietaryIngredient];
          }
          return acc;
        }, [] as DietaryRestrictionsText[]) || [];

      return [...acc, ...dietaryIngredients];
    }, [] as DietaryRestrictionsText[]) || [];

  // de-dupe
  return Array.from(new Set(dietaryIngredients));
};
